module.exports = __webpack_public_path__ + "img/promo3.10bb45e3.png";